import i18n from 'i18n';

export const PreferredDeliveryTime = {
  morning: 9,
  afternoon1: 14,
  afternoon2: 17,
  night: 18,
  none: 0
};

export const PreferredTimeOptions = [
  {
    label: i18n.t('orderAggregators:payment:delivery.morning'),
    value: PreferredDeliveryTime.morning
  },
  {
    label: i18n.t('orderAggregators:payment:delivery.afternoon1'),
    value: PreferredDeliveryTime.afternoon1
  },
  {
    label: i18n.t('orderAggregators:payment:delivery.afternoon2'),
    value: PreferredDeliveryTime.afternoon2
  },
  {
    label: i18n.t('orderAggregators:payment:delivery.night'),
    value: PreferredDeliveryTime.night
  },
  {
    label: i18n.t('orderAggregators:payment:delivery.none'),
    value: PreferredDeliveryTime.none
  }
];



// WEBPACK FOOTER //
// ./src/constants/preferred-delivery-time.js